import React from "react";

const NotFound = ({ message }) => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <h1 className="display-1">404</h1>
        <p className="lead">{message}</p>
      </div>
    </div>
  );
};

export default NotFound;
